import { OASListing } from '../features/listing/listing';

export default OASListing;
